var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconcheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11,22a10.95,10.95,0,0,1-6.15-1.879,11.033,11.033,0,0,1-3.985-4.84A10.985,10.985,0,0,1,1.879,4.85,11.03,11.03,0,0,1,6.719.864,10.986,10.986,0,0,1,17.15,1.879a11.033,11.033,0,0,1,3.985,4.84A10.985,10.985,0,0,1,20.121,17.15a11.03,11.03,0,0,1-4.84,3.985A10.931,10.931,0,0,1,11,22ZM6.394,11.044h0l-.7.7,3.339,3.376L16.5,7.58l-.7-.7L9.036,13.716,6.394,11.044Z",
    transform: "translate(1 1)",
    fill: "#1EAE9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconcheckCircle);
export default __webpack_public_path__ + "static/media/icon.check-circle.b3bbc27812d09904920eaa5fb3617877.svg";
export { ForwardRef as ReactComponent };